import api from '@/services/Api';

class RentalProductAvailabilityStatusService {
  async getRentalProductAvailabilityStatusList() {
    const response =
      await api.get('/rental/distributor/availability-status')
    return response.data
  }
}

export default new RentalProductAvailabilityStatusService();
